import React from 'react';
import { useTranslation } from 'react-i18next';
import './home.css';
import './privacy.css';

import FadeInSection from '../animation/fadein_onscroll';

document.querySelectorAll('a[data-scroll]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

function Privacy() {
  const { t } = useTranslation();
  return (
    <div className="subpage-padding" id='start'>
      <FadeInSection>
        <h1>{t('privacy.title')}</h1>
        <br />
        <p>{t('privacy.date')}</p>
      </FadeInSection>
      <br />
      <div className="max-width">
        <FadeInSection>
          <p>{t('privacy.intro.overview1')}</p>
          <p>{t('privacy.intro.overview2')}</p>
          <p>{t('privacy.intro.overview3')}</p>
          <p>{t('privacy.intro.overview4')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.dataCollection.title')}</h3>
          <p>{t('privacy.dataCollection.text1')}</p>
          <p>{t('privacy.dataCollection.text2')}</p>
          <p>{t('privacy.dataCollection.text3')}</p>
          <p>{t('privacy.dataCollection.text4')}</p>
          <p>{t('privacy.dataCollection.text5')}</p>
          <p>{t('privacy.dataCollection.text6')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.legalBasis.title')}</h3>
          <p>{t('privacy.legalBasis.text1')}</p>
          <p>{t('privacy.legalBasis.text2')}</p>
          <p>{t('privacy.legalBasis.text3')}</p>
          <p>{t('privacy.legalBasis.text4')}</p>
          <p>{t('privacy.legalBasis.text5')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.transferAndStorage.title')}</h3>
          <p>{t('privacy.transferAndStorage.text1')}</p>
          <p>{t('privacy.transferAndStorage.text2')}</p>
          <p>{t('privacy.transferAndStorage.text3')}</p>
          <p>{t('privacy.transferAndStorage.text4')}</p>
          <p>{t('privacy.transferAndStorage.text5')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.rights.title')}</h3>
          <p>{t('privacy.rights.text1')}</p>
          <p>{t('privacy.rights.text2')}</p>
          <p>{t('privacy.rights.text3')}</p>
          <p>{t('privacy.rights.text4')}</p>
          <p>{t('privacy.rights.text5')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.cookies.title')}</h3>
          <p>{t('privacy.cookies.text1')}</p>
          <p>{t('privacy.cookies.text2')}</p>
          <p>{t('privacy.cookies.text3')}</p>
          <p>{t('privacy.cookies.text4')}</p>
          <p>{t('privacy.cookies.text5')}</p>
          <p>{t('privacy.cookies.text6')}</p>
          <p>{t('privacy.cookies.text7')}</p>
          <p>{t('privacy.cookies.text8')}</p>
          <p>{t('privacy.cookies.text9')}</p>
          <p>{t('privacy.cookies.text10')}</p>
          <p>{t('privacy.cookies.text11')}</p>
          <p>{t('privacy.cookies.text12')}</p>
          <p>{t('privacy.cookies.text13')}</p>
          <p>{t('privacy.cookies.text14')}</p>
          <p>{t('privacy.cookies.text15')}</p>
          <p>{t('privacy.cookies.text16')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('privacy.contact.title')}</h3>
          <p>
            {t('privacy.contact.text1')} <a className="link" href="mailto:contact@qualityfoodcontrol.com">contact@qualityfoodcontrol.com</a>.
          </p>
        </FadeInSection>

        <br />
        <br />
        <br />
        <br />

        <FadeInSection>
          <h2>{t('dpa.title')}</h2>
        </FadeInSection>
        <br />
        <FadeInSection>
          <h3>{t('dpa.section1.title')}</h3>
          <p>{t('dpa.section1.text1')}</p>
        </ FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section2.title')}</h3>
          <p>{t('dpa.section2.text1')}</p>
        </ FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section3.title')}</h3>
          <p>{t('dpa.section3.text1')}</p>
          <p>{t('dpa.section3.text2')}</p>
          <p>{t('dpa.section3.text3')}</p>
        </ FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section4.title')}</h3>
          <p>{t('dpa.section4.intro')}</p>
          <ul className="alpha-list">
            <li>{t('dpa.section4.list.a')}</li>
            <li>{t('dpa.section4.list.b')}</li>
            <li>{t('dpa.section4.list.c')}</li>
            <li>{t('dpa.section4.list.d')}</li>
            <li>{t('dpa.section4.list.e')}</li>
            <li>{t('dpa.section4.list.f')}</li>
            <li>{t('dpa.section4.list.g')}</li>
            <li>{t('dpa.section4.list.h')}</li>
          </ul>
          <p>{t('dpa.section4.text2')}</p>
          <p>{t('dpa.section4.text3')}</p>
        </ FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section5.title')}</h3>
          <p>{t('dpa.section5.text1')}</p>
          <p>{t('dpa.section5.text2')}</p>
          <p>{t('dpa.section5.text3')}</p>
          <p>{t('dpa.section5.text4')}</p>
          <ul className="alpha-list">
            <li>{t('dpa.section5.list.a')}</li>
            <li>{t('dpa.section5.list.b')}</li>
            <li>{t('dpa.section5.list.c')}</li>
            <li>{t('dpa.section5.list.d')}</li>
          </ul>
          <p>{t('dpa.section5.text5')}</p>
          <p>{t('dpa.section5.text6')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section6.title')}</h3>
          <p>{t('dpa.section6.text1')}</p>
          <p>{t('dpa.section6.text2')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section7.title')}</h3>
          <p>{t('dpa.section7.text1')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section8.title')}</h3>
          <p>{t('dpa.section8.text1')}</p>
          <p>{t('dpa.section8.text2')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section9.title')}</h3>
          <p>{t('dpa.section9.text1')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
          <h3>{t('dpa.section10.title')}</h3>
          <p>{t('dpa.section10.text1')}</p>
        </FadeInSection>
        <FadeInSection>
          <h3>{t('dpa.section11.title')}</h3>
          <p>{t('dpa.section11.text1')}</p>
          <p>{t('dpa.section11.text2')}</p>
          <p>{t('dpa.section11.text3')}</p>
        </FadeInSection>
        <FadeInSection>
          <h3>{t('dpa.section12.title')}</h3>
          <p>{t('dpa.section12.text1')}</p>
        </FadeInSection>
        <FadeInSection>
          <h3>{t('dpa.section13.title')}</h3>
          <p>{t('dpa.section13.text1')}</p>
        </FadeInSection>
        <FadeInSection>
          <h3>{t('dpa.section14.title')}</h3>
          <p>{t('dpa.section14.text1')}</p>
        </FadeInSection>
      </div>
    </div>
  );
}

// ReactDOM.render(<App />, document.getElementById('root'));

export default Privacy;
